import React from 'react';
import { Trash2 } from 'lucide-react';
import { rb, RBField, RBInput, RBTextArea, RBAddButton, RBEmptyHint } from '../theme';
import AIEnhanceButton from '../AIEnhanceButton';
import { emptyExperience } from '../sectionShapes';

export default function ExperienceStep({ state, setState, sessionId }) {
  const updateRow = (i, key, value) =>
    setState((s) => ({
      ...s,
      experiences: s.experiences.map((row, idx) => (idx === i ? { ...row, [key]: value } : row)),
    }));

  const addRow = () => setState((s) => ({ ...s, experiences: [...s.experiences, emptyExperience()] }));
  const removeRow = (i) =>
    setState((s) => ({ ...s, experiences: s.experiences.filter((_, idx) => idx !== i) }));

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-400">
        Add your jobs, latest first. No work experience yet? Just tap Next to skip this step.
      </p>

      {state.experiences.length === 0 && <RBEmptyHint>No jobs added yet.</RBEmptyHint>}

      {state.experiences.map((exp, i) => (
        <div key={i} className={`rounded-2xl p-4 space-y-3 ${rb.glassSoft}`}>
          <div className="flex items-center justify-between">
            <span className="text-xs font-bold uppercase tracking-wide text-violet-300">Job {i + 1}</span>
            <button type="button" onClick={() => removeRow(i)} className="p-1.5 rounded-lg text-red-400 hover:bg-white/5" aria-label="Remove this job">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
          <div className="grid sm:grid-cols-2 gap-3">
            <RBField label="Job title *">
              <RBInput value={exp.title} onChange={(e) => updateRow(i, 'title', e.target.value)} placeholder="e.g. Delivery Executive" />
            </RBField>
            <RBField label="Company *">
              <RBInput value={exp.company} onChange={(e) => updateRow(i, 'company', e.target.value)} placeholder="e.g. Zomato" />
            </RBField>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <RBField label="From">
              <RBInput value={exp.start} onChange={(e) => updateRow(i, 'start', e.target.value)} placeholder="e.g. Jan 2022" />
            </RBField>
            <RBField label="To">
              <RBInput
                value={exp.current ? '' : exp.end}
                onChange={(e) => updateRow(i, 'end', e.target.value)}
                placeholder={exp.current ? 'Present' : 'e.g. Mar 2024'}
                disabled={exp.current}
              />
            </RBField>
          </div>
          <label className="flex items-center gap-2 text-sm text-slate-200">
            <input type="checkbox" checked={exp.current} onChange={(e) => updateRow(i, 'current', e.target.checked)} className="accent-violet-500 w-4 h-4" />
            I currently work here
          </label>
          <RBField label="What did you do there?">
            <RBTextArea
              rows={3}
              value={exp.description}
              onChange={(e) => updateRow(i, 'description', e.target.value)}
              placeholder="e.g. Delivered 40+ orders daily. Kept a 4.8 customer rating."
            />
            <AIEnhanceButton sessionId={sessionId} sectionType="experience" text={exp.description} onAccept={(t) => updateRow(i, 'description', t)} />
          </RBField>
        </div>
      ))}

      <RBAddButton label="Add a job" onClick={addRow} />
    </div>
  );
}
